<script>
    /*
    	DataNumberField.svelte
    */

    import {onMount} from 'svelte';
    import { getFieldStyle } from '../../common/data-fields.js';

    // TCARE components

    // SMUI components
    import Tooltip, {Wrapper} from '@smui/tooltip';
    import {Icon} from '@smui/icon-button';
    import {Svg} from '@smui/common/elements';
    import {mdiClose, mdiChevronRightBox} from '@mdi/js';


    export let value;           // two way binding for the input changes
    export let propName;        // pass to onCopyValue for field to use
    export let label;           // the caption for the field
    export let isEditable;      // if false show as gray disabled
    export let isOrigDiff;      // if true show strike-thru
    export let isNewDiff;       // if true show yellow highlight
    export let onCopyValue;     // null or external setter function
    export let tooltip;         // if not blank will show in popover
    export let showDiffs;       // bypass the strike-through and highlighting
    export let isFloat;

    let originalValue;

    $: isDirty = originalValue !== value;
    $: fieldStyle = getFieldStyle(isEditable, isOrigDiff, isNewDiff, isDirty, showDiffs);

    // set originalValue one time only!
    onMount(() => {
        originalValue = value;                      // might be null
    });

    // TODO: must also reset the store, not just the field's value!
    // correction - because this is bound, the store is getting reset
    // 8/25 - MUST MAKE AN ARRAY FIELD TYPE (SIMILAR TO TAXONOMYFIELD)
    const resetValue = () => {
        value = originalValue;
    }

    const onInputFocus = (e) => {
        if (!isEditable) e.target.blur();
    }

    const onInputBlur = (e) => {
    }

    const _onCopyValue = () => {
        if (onCopyValue) onCopyValue(propName);              // call parent function
    }

</script>

<style>

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="data-field">
    <div class="label">
        {label}
    </div>

    <!-- only show tooltip if there is text there! -->
    <div class="value">
        <Wrapper>
            {#if isFloat}
                <input type="number" class="ellipsis" step="0.1" pattern="[0-9]{1}\.[0-9]{1}" bind:value={value}
                       on:focus={onInputFocus} on:blur={onInputBlur} style={fieldStyle}>
            {:else}
                <input type="number" class="ellipsis" bind:value={value} on:focus={onInputFocus} on:blur={onInputBlur}
                       style={fieldStyle}>
            {/if}
            {#if tooltip && tooltip !== ''}
                <Tooltip xPos="start" yPos="above">{tooltip}</Tooltip>
            {/if}
        </Wrapper>
    </div>

    <div class="icons">
        <!-- the "copy to" icon - call parent's function -->
        {#if onCopyValue}
            {#if value && value !== ''}
                <div class="icon" on:click={_onCopyValue}>
                    <Icon component={Svg} viewBox="0 0 24 24">
                        <path d={mdiChevronRightBox}/>
                    </Icon>
                </div>
            {/if}
        {/if}

        {#if isEditable && isDirty}
            <div class="icon" on:click={() => resetValue()}>
                <Icon component={Svg} viewBox="0 0 24 24">
                    <path d={mdiClose}/>
                </Icon>
            </div>
        {/if}
    </div>
</div>

